import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { getContentfulSrc, getContentfulSrcSet } from '../../utils/contentfulUtils.js';

const ContentfulImage = ({ src, alt, targetLink, sizes, loading = 'lazy', responsiveSizes, defaultWidth, defaultHeight, className, isPNG, }) => {
    const fallbackFormatTag = isPNG ? 'fl=progressive' : 'fm=jpeg&fl=progressive';
    const modernFormatTag = isPNG ? 'fl=progressive' : 'fm=webp';
    const image = (jsxs("picture", { children: [jsx("source", { src: defaultWidth
                    ? getContentfulSrc(src, modernFormatTag, `${defaultWidth}`)
                    : getContentfulSrc(src, modernFormatTag), srcSet: getContentfulSrcSet(src, modernFormatTag, sizes), type: "image/webp" }), jsx("img", { src: defaultWidth
                    ? getContentfulSrc(src, fallbackFormatTag, `${defaultWidth}`)
                    : getContentfulSrc(src, fallbackFormatTag), sizes: responsiveSizes, alt: alt, className: className, loading: loading, width: defaultWidth ? defaultWidth : 'auto', height: defaultHeight ? defaultHeight : 'auto' })] }));
    return (jsxs(Fragment, { children: [targetLink && (jsx("a", { href: targetLink, target: "_self", children: image })), !targetLink && image] }));
};

export { ContentfulImage as default };
//# sourceMappingURL=ContentfulImage.js.map
